const romeveFilesHost = (files) => {
  if (!files || files.length === 0) return [];

  const processFile = (file) => {
    if (typeof file !== 'string') return file;
    const splitWord = file.includes('dev_pictures') ? 'dev_pictures' : 'pictures';
    const parts = file.split(splitWord);
    return parts.length > 1 ? splitWord + parts[1] : file;
  };

  if (Array.isArray(files)) {
    return files.map(processFile);
  }

  return processFile(files);
};

const cleanEditionData = (data) => {
  const {
    show_contact,
    show_branch,
    pictures,
    show_operation_sale,
    description,
    title,
    show_location,
    videos,
    show_operation_temporary_rent,
    show_operation_rent,
    development,
    show_agent,
    show_logo,
    agent_user,
    custom_branch,
  } = data;

  const { images = [], front_cover_image = [], blueprints = [] } = pictures;
  const { normal, 360: videos360 } = videos;

  const final_visible_photos = front_cover_image?.url
    ? [front_cover_image.url, ...images, ...blueprints]
    : [...images, ...blueprints];

  const cleanData = {
    show_contact,
    show_branch,
    cover_photo: front_cover_image?.url || "url.picture.com",
    visible_photos: romeveFilesHost(final_visible_photos),
    show_operation_sale,
    custom_description: description || "test description",
    custom_title: title,
    show_location,
    visible_videos: [...normal, ...videos360],
    show_operation_temporary_rent,
    show_operation_rent,
    custom_agent: agent_user.id,
    custom_branch: custom_branch?.id || "",
    custom_development_description:
      development?.description || "test description development",
    show_agent,
    show_logo,
  };
  return cleanData;
};

export default cleanEditionData;
